let numSlides = $('.carousel-test .test').length;
$('.carousel-test').owlCarousel({
	dots: true,
	items: 1.3,
	stagePadding: 300,
	center: true,
	margin: 34,
	nav: false,
	loop: numSlides > 1,
	autoplay: true,
	animateOut: 'fadeOut',
	animateIn: 'fadeIn',
	autoplayTimeout: 3000,
	smartSpeed: 1000,
	lazyLoad: true,
	responsive: {
		0: {
			stagePadding: 32,
			items: 1,
		},
		1000: {
			stagePadding: 100,
			items: 1.3,
		},
		1300: {
			stagePadding: 150,
			items: 1.3,
		},
		1500: {
			stagePadding: 300,
			items: 1.3,
		},
	},
});

